import { Injectable } from '@angular/core';

import { Observable, forkJoin } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import {DataService} from './data.service';

const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userProfileCache$: Observable<any>;

  constructor(private dataService: DataService) {}

  /**
   * Retrieve the consolidated user, platform, and profile
   */
  getUserProfile(): Observable<any> {
    if (!this.userProfileCache$) {
      this.userProfileCache$ = forkJoin(
        this.dataService.getProfile()
      )
      .pipe(
        map(result => {
          const data = {
            profile: result[0]
          };
          const user: any = {platform: 'DH'};
          try {
            user.profile = data.profile[user.platform]['ROLE_USER'];
          } catch (error) {
            console.error(error.message);
            user.profile = {};
          }
          return user;
        }),
        shareReplay(CACHE_SIZE)
      );
    }
    return this.userProfileCache$;
  }

  _getUserProfile(): Observable<any> {
    return this.dataService.getUserMock();
  }

}
